var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-form" }, [
    _c(
      "form",
      {
        staticClass: "search-form__form",
        attrs: { action: "/catalog/search/", method: "get" },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.queryProduct,
              expression: "queryProduct",
            },
          ],
          staticClass: "search-form__field",
          attrs: {
            name: "query",
            autocomplete: "off",
            type: "text",
            placeholder: "Искать в каталоге",
          },
          domProps: { value: _vm.queryProduct },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.queryProduct = $event.target.value
              },
              function ($event) {
                $event.target.composing = false
              },
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "search-form__submit", attrs: { type: "submit" } },
          [
            !_vm.requestProcess
              ? _c("i", { staticClass: "fa fa-magnifying-glass" })
              : _vm._e(),
            _vm._v(" "),
            _vm.requestProcess
              ? _c("i", { staticClass: "fa fa-spinner fa-spin-pulse" })
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.resultsNotEmpty
      ? _c("div", { staticClass: "search-form__results search-results" }, [
          _vm.categoriesResults && _vm.categoriesResults.length > 0
            ? _c(
                "div",
                { staticClass: "search-results__categories results-group" },
                [
                  _c("div", { staticClass: "results-group__title" }, [
                    _vm._v("В категориях"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "results-group__items search-result-items" },
                    _vm._l(_vm.categoriesResults, function (category) {
                      return _c(
                        "li",
                        { staticClass: "search-result-items__item" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "search-result-item",
                              attrs: { href: category.get_absolute_url },
                            },
                            [
                              category.thumbnail_icon
                                ? _c(
                                    "span",
                                    { staticClass: "search-result-item__icon" },
                                    [
                                      _c("img", {
                                        staticClass: "search-result-item__img",
                                        attrs: {
                                          src:
                                            _vm.baseUrl +
                                            category.thumbnail_icon,
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "search-result-item__content" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "search-result-item__name" },
                                    [_vm._v(_vm._s(category.name))]
                                  ),
                                  _vm._v(" "),
                                  category.root_category_name
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "search-result-item__root-category",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                category.root_category_name
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productsResults && _vm.productsResults.length > 0
            ? _c("div", { staticClass: "search-results__products" }, [
                _c("div", { staticClass: "results-group__title" }, [
                  _vm._v("В товарах"),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "results-group__items search-result-items" },
                  _vm._l(_vm.productsResults, function (product) {
                    return _c(
                      "li",
                      { staticClass: "search-result-items__item" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "search-result-item",
                            attrs: { href: product.get_absolute_url },
                          },
                          [
                            product.thumbnail_icon
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "search-result-item__icon search-result-item__icon--product",
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "search-result-item__img search-result-item__img--product",
                                      attrs: {
                                        src:
                                          _vm.baseUrl + product.thumbnail_icon,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "search-result-item__content" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "search-result-item__code product-code",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "product-code__label" },
                                      [_vm._v("Код товара:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "product-code__value" },
                                      [_vm._v(_vm._s(product.id))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "search-result-item__root-category",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(product.category.name) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "search-result-item__name" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(product.name) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "search-result-item__price product-search-price",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "product-search-price__value",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(product.price.toFixed(0)) +
                                            " руб.\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    product.is_sale
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "product-search-price__value product-search-price__value--raw",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  product.price_raw.toFixed(0)
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "search-results__actions" }, [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-outline btn-outline--tertiary search-results__btn",
                attrs: { href: "/catalog/search/?query=" + _vm.queryProduct },
              },
              [_vm._v("Все результаты")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }